export const colors = {
  palette: {
    black: "#141414",
    blue: "#2686df",
    grey: "#4b4b4b",
    lightgrey: "#cacaca",
    white: "#ffffff",
    orange: "#f56514",
    green: "#7db437",
    transparent: "transparent",
  },
  button: {
    default: {
      backgroundColor: "#2686df",
      textColor: "#ffffff",
    },
    disabled: {
      backgroundColor: "#eff3f6",
      textColor: "#c0d0db",
    },
    primary: {
      backgroundColor: "#2686df",
      textColor: "#ffffff",
    },
    secondary: {
      backgroundColor: "#ffffff",
      borderColor: "#2686df",
      textColor: "#2686df",
    },
  },
  input: {
    background: "#ffffff",
    color: "#141414",
    focused: "#2686df",
    placeholder: "#626262",
  },
  text: {
    color: "#141414",
    error: "#f56514",
    focused: "#2686df",
    highlighted: "#f56514",
    lightColor: "#4b4b4b",
    veryLightColor: "#cacaca",
    placeholder: "#626262",
  },
  theme: {
    background: "#f6f6f6",
    bottomNavigation: "#ffffff",
    icon: "#ffffff",
  },
  menu: {
    item: "#2686df",
    description: "#4b4b4b",
    badge: "#dc3545",
    error: "#dc3545",
  },
  logo: {
    gradient: ["#fa7373", "#4869dc", "#7851e7", "#7851e7"],
  },
};
